import React from 'react';
import styled from 'styled-components';
import { DatepickerRange } from '../../utils/datepicker-range';
import { useLang } from "@@Components/hooks/useLang";
import dayjs from 'dayjs';
const DaysMatrixWrapper = styled.div `
  padding: 15px;
`;
const DaysLabels = styled.div `
  width: 100%;
  display: flex;
  align-items: center;
`;
const DayLabel = styled.div `
  width: calc(100% / 7);
  font-weight: 800;
`;
const DaysContainer = styled.div `
  display: flex;
  flex-flow: row wrap;
`;
const Day = styled.div `
  width: calc(100% / 7);
  padding: 5px 0;
  &:hover { text-decoration: underline; }
  ${props => props.selected && `
    font-weight: 800;
    color: ${props.theme.colors.primary};
  `};
  ${props => props.disabled ? 'pointer-events: none;opacity: .5;' : ''};
  ${props => !props.disabled && props.day && 'cursor: pointer;'};
  ${props => props.current && `
    font-weight: 800;
    color: ${props.theme.colors.primary};
  `}
`;
export const DaysMatrix = ({ minimalDate, datepicker, blockSunday, onChange, options, }) => {
    const { translate } = useLang();
    let DAYS = ['pn', 'wt', 'śr', 'czw', 'pt', 'sb', 'nd'];
    try {
        DAYS = translate('datepicker.days').split(',');
    }
    catch (e) { }
    const handleDayChange = (day) => onChange && onChange(day, DatepickerRange.DAY);
    const checkIsDaySunday = (date) => {
        if (date.getDay() === 0) {
            return true;
        }
    };
    const isDisabled = (day) => {
        if (day && minimalDate) {
            const date = new Date(datepicker.getYear(), datepicker.getMonth(), day);
            if (dayjs(minimalDate).diff(date, 'day') > 0)
                return true;
            else {
                if (blockSunday)
                    return checkIsDaySunday(date);
            }
        }
        else {
            if (blockSunday && day) {
                const date = new Date(datepicker.getYear(), datepicker.getMonth(), day);
                return checkIsDaySunday(date);
            }
            return false;
        }
    };
    return React.createElement(DaysMatrixWrapper, null,
        React.createElement(DaysLabels, null, DAYS.map(day => (React.createElement(DayLabel, { key: day }, day)))),
        React.createElement(DaysContainer, null, datepicker.getDaysMatrix().map((day, i) => {
            if (isDisabled(day)) {
                return (React.createElement(Day, { key: i, selectable: day !== null, current: datepicker.isCurrent(day), disabled: true, selected: datepicker.isSelectedDay(day) }, day));
            }
            else {
                return (React.createElement(Day, { key: i, selectable: day !== null, current: datepicker.isCurrent(day), disabled: false, day: day, selected: day && datepicker.isSelectedDay(day), onClick: () => day && handleDayChange(day) }, day));
            }
        })));
};
